import React from 'react';

const Header: React.FC = () => {
  return (
    <div className="bg-gray-800 text-white p-4 shadow-md">
      <h1 className="text-2xl font-bold text-center">TRINETRA - Geological Event Monitoring</h1>
    </div>
  );
};

export default Header;
